import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { singleAuctionDetails } from "../../../../redux/action/singleAuction";
import AuctionSchedule from "../comman/AuctionSchedule";
import CatelogueInSeller from "./component/CatelogueInSeller";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-materialize";
import {
  startingPriceApproval,
  startingPriceReject,
} from "../../../../redux/action/price";
import ServiceLotListTable from "./table/ServiceLotListTable";


function ServiceSingleAuctionPage() {
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width: 800px)" });
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const { id } = useParams();
  const path = localStorage.getItem("pathurl");
  const dispatch = useDispatch();
  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );
  const { approvelLoading } = useSelector((pre) => pre.startingPriceApproval);
  const priceStatus = singleAuctionData?.startingPriceApproval?.status;
  const closeRejectModal = () => {
    setIsRejectModalOpen(false);
  };

  const closeAcceptModal = () => {
    setIsAcceptModalOpen(false);
  };

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
  }, [dispatch, id]);

  return (
    <div className="flex column gap-1">
      <span>
        <div className="valign-wrapper space-between">
          <span
            className={`valign-wrapper`}
            style={{ gap: "25px" }}
          >
            <span
              className="material-icons-outlined pointer"
              onClick={() => navigate(path === "/" ? "/" : "/auction-status")}
            >
              arrow_back
            </span>

            <h4>Auction Id: {singleAuctionData?.auctionId}</h4>
          </span>
        </div>
        <AuctionSchedule
          singleAuctionData={singleAuctionData}
          loading={loading}
        />
      </span>
      <div>
        <div className={`valign-wrapper space-between ${!isTablet?"":"flex-wrap gap-1"}`}>
          <h5 className="margin-0px">Lots List</h5>
          {priceStatus !== "approval" &&
            !loading &&
            singleAuctionData?.offers?.[0]?.startingPrice > 0 && (
              <span className="valign-wrapper justify-center gap-10px">
                {priceStatus === "rejected" && (
                  <p className="mr-1">
                    Status:{" "}
                    <span className="red-text">
                      Starting price has been rejected by you.
                    </span>
                  </p>
                )}
                <button
                  className="button-style pointer white-text green"
                  style={{ padding: "6px 15px" }}
                  onClick={() => setIsAcceptModalOpen(true)}
                >
                  Accept Starting Price
                </button>
                <button
                  className={`button-style pointer ${priceStatus === "rejected"
                      ? "grey lighten-2"
                      : "white-text red"
                    }`}
                  style={{ padding: "6px 15px" }}
                  disabled={priceStatus === "rejected"}
                  onClick={() => setIsRejectModalOpen(true)}
                >
                  Reject Starting Price
                </button>
              </span>
            )}
        </div>
        <ServiceLotListTable
          offers={singleAuctionData?.offers}
          loading={loading}
          status={singleAuctionData?.status}
        />
      </div>

      <div>
        <h5 className="margin-0px">Catalogue status</h5>
        <CatelogueInSeller />
      </div>
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalView-details"
        open={isAcceptModalOpen}
        options={{
          onCloseEnd: closeAcceptModal,
        }}
      >
        <div>
          <h5>
            Do you want to confirm and accept the lot price? Click confirm to
            proceed.
          </h5>
        </div>

        <div className="flex justify-end gap-1 mt-1">
          <button
            className="green btn-small"
            onClick={() =>
              dispatch(startingPriceApproval(id, setIsAcceptModalOpen))
            }
          >
            {approvelLoading ? (
              <ClipLoader color={"#fff"} size={20} />
            ) : (
              "Confirm"
            )}
          </button>
          <button
            className="red btn-small modal-close"
            onClick={() => setIsAcceptModalOpen(false)}
          >
            No
          </button>
        </div>
      </Modal>
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalView-details"
        open={isRejectModalOpen}
        options={{
          onCloseEnd: closeRejectModal,
        }}
      >
        <div>
          <h5>Are you sure, You want to reject the lot price?</h5>
        </div>

        <div className="flex justify-end gap-1 mt-1">
          <button
            className="green btn-small valign-wrapper justify-center"
            onClick={() =>
              dispatch(startingPriceReject(id, setIsRejectModalOpen))
            }
          >
            {approvelLoading ? <ClipLoader color={"#fff"} size={20} /> : "Yes"}
          </button>
          <button
            className="red btn-small modal-close"
            onClick={() => setIsRejectModalOpen(false)}
          >
            No
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default ServiceSingleAuctionPage;
